import { Rate } from "antd";
import { getStyle } from "../../hooks/use-styles";
import { getLabel } from "../../hooks/use-labels";
import "./style.css";

const HexRatingReviews = ({
  rating,
  totalRatings,
  hideTextRating,
  enabled,
  className,
  reviewText,
  textClass,
  onClick,
  outOf,
  decimalRating,
}) => {
  const hasRating = +totalRatings > 0;
  return (
    <div className={`flex align-center  hex-rating ${className || ""}`}>
      {!hideTextRating && (
        <span
          style={{ color: getStyle("black") }}
          className={`text-base ${textClass || ""}`}
        >
          {rating}
        </span>
      )}
      <Rate defaultValue={rating} disabled={!enabled} allowHalf />
      {+totalRatings >= 0 && (
        <span
          onClick={() => hasRating && onClick()}
          style={{ color: getStyle("grey") }}
          className={`text-sm  ${
            hasRating ? "underline-text pointer" : "default-cursor"
          }`}
        >{`(${totalRatings}${reviewText ? ` ${reviewText}` : ""})`}</span>
      )}
      {outOf && (
        <span className="font-16-normal-400-lh-22 gray-color">{`${rating} ${getLabel(
          "outOf"
        )} 5`}</span>
      )}

      {decimalRating && (
        <span className="font-16-normal-400-lh-22 gray-color">{`${rating.toFixed(
          1
        )}`}</span>
      )}
    </div>
  );
};

export default HexRatingReviews;
